import React, { Component } from "react";
import { Col, Row, Button, Input } from "antd";
import { strings } from "../../helpers";
import { Link } from "react-router-dom";
import openDetailModal from "./DemoDetailModal";
import DemoDetailModal from "./DemoDetailModal";

export default class DemoDetailView extends Component {
  render() {
    const {
      toggleDetailModal,
      openDetailModal,
      userPhoneNumber,
      handleButtonClick,
      generateData,
      isProcessing,
      handleInputChange
    } = this.props;

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="start" align="middle" gutter={20}>
            <Col span={5}>
              <Button type="primary" onClick={() => handleButtonClick("cms")}>
                Populate data for CMS
              </Button>
            </Col>
            <Col span={19}>
              <Button
                type="primary"
                onClick={() => handleButtonClick("growth")}
              >
                Populate data for Growth
              </Button>
            </Col>
          </Row>
          <DemoDetailModal
            toggleDetailModal={toggleDetailModal}
            openDetailModal={openDetailModal}
            userPhoneNumber={userPhoneNumber}
            generateData={generateData}
            handleInputChange={handleInputChange}
            isProcessing={isProcessing}
          />
        </div>
      </div>
    );
  }
}
